interface Faq {
  question: string;
  answer: string;
}

const faqHeadingByLanguage = {
  English: "FAQs (Frequently Asked Questions)",
  Arabic: "الأسئلة الشائعة",
  Bengali: "প্রায়শই জিজ্ঞাস্য প্রশ্নাবলী",
  Bulgarian: "Често задавани въпроси",
  Chinese: "常见问题解答",
  Croatian: "Često postavljana pitanja",
  Czech: "Často kladené dotazy",
  Danish: "Ofte stillede spørgsmål",
  Dutch: "Veelgestelde vragen",
  Estonian: "Korduma kippuvad küsimused",
  Finnish: "Usein kysytyt kysymykset",
  French: "Questions fréquemment posées",
  Georgian: "ხშირად დასმული კითხვები",
  German: "Häufig gestellte Fragen",
  Greek: "Συχνές Ερωτήσεις",
  Hebrew: "שאלות נפוצות",
  Hindi: "अक्सर पूछे जाने वाले प्रश्न",
  Hungarian: "Gyakran Ismételt Kérdések",
  Indonesian: "Pertanyaan yang Sering Diajukan",
  Italian: "Domande frequenti",
  Japanese: "よくある質問",
  Korean: "자주 묻는 질문",
  Latvian: "Bieži uzdotie jautājumi",
  Lithuanian: "Dažnai užduodami klausimai",
  Malay: "Soalan Lazim",
  Maltese: "Mistoqsijiet Frekwenti",
  Norwegian: "Ofte stilte spørsmål",
  Polish: "Najczęściej zadawane pytania",
  Portuguese: "Perguntas Frequentes",
  Romanian: "Întrebări frecvente",
  Russian: "Часто задаваемые вопросы",
  Serbian: "Често постављана питања",
  Slovak: "Často kladené otázky",
  Slovenian: "Pogosto zastavljena vprašanja",
  Spanish: "Preguntas frecuentes",
  Swedish: "Vanliga frågor",
  Tamil: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
  Thai: "คำถามที่พบบ่อย",
  Turkish: "Sıkça Sorulan Sorular",
  Ukrainian: "Часто задавані питання",
  Vietnamese: "Câu hỏi thường gặp",
};

export const buildJsonLd = (faq: { question: string; answer: string }[]) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((item) => {
      return {
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      };
    }),
  };
};

export const faqToHtml = (faqs: Faq[], language?: string) => {
  let text = `<h2>${faqHeadingByLanguage[language || "English"]}</h2>`;
  faqs.forEach((faq) => {
    text += `<h3>${faq.question}</h3><p>${faq.answer}</p>`;
  });
  return text;
};

export const faqToMarkdown = (faqs: Faq[], language?: string) => {
  let text = `## ${faqHeadingByLanguage[language || "English"]}
`;
  faqs.forEach((faq) => {
    text += `### ${faq.question}\n\n${faq.answer}\n\n`;
  });
  return text;
};

export const faqToMarkup = (faqs: Faq[]) => {
  return `<script type="application/ld+json">${JSON.stringify(
    buildJsonLd(faqs)
  )}</script>`;
};
